import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, DeferLoadingStrategy, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { MyAccountPermissionsAuthGuard } from '../../myaccount/guards/myaccount-permissions-auth.guard';
import { CheckoutCartIsValidatedGuard } from '../guards/checkout-cart-validated-guard';
import { CheckoutPlaceOrderComponent } from './checkout-place-order.component';

@NgModule({
  imports: [CommonModule, I18nModule, RouterModule, UrlModule, CheckoutPlaceOrderComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutPlaceOrder: {
          component: CheckoutPlaceOrderComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutCartIsValidatedGuard, MyAccountPermissionsAuthGuard],
        },
      },
    }),
  ],
  exports: [CheckoutPlaceOrderComponent],
})
export class CheckoutPlaceOrderModule {}
